import { render, staticRenderFns } from "./AddNominationDocuments.vue?vue&type=template&id=7ef3c400"
import script from "./AddNominationDocuments.vue?vue&type=script&lang=js"
export * from "./AddNominationDocuments.vue?vue&type=script&lang=js"
import style0 from "./AddNominationDocuments.vue?vue&type=style&index=0&id=7ef3c400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports